import { Conditional } from '@cat-ecom/pcc-components';
import AvailabilityTitle from '../availability-title/availability-title';
import { PrimaryAvailabilityProps } from '../types';
import AvailabilityPickupText from '../availability-pickup-text';
import { HoseAssemblyDetails } from 'components/hose-assembly-details/hose-assembly-details';
import { shouldShowContactDealer } from '../utils';
import ContactYourDealerPopover from 'components/contact-your-dealer/contact-your-dealer-popover/contact-your-dealer-popover';
import React from 'react';

const PrimaryAvailability = ({
  availabilityInformation,
  hideLabel,
  availabilityToolTipMessage,
  isDeliveryEnabled,
  isPickupEnabled,
  hoseAssemblyDetails,
  address,
  showAdditionalInfo = false,
  hideToolTipIcon
}: PrimaryAvailabilityProps) => {
  const { hoseAssemblyIndicator, hoseAvailabilityLabel } =
    hoseAssemblyDetails || {};
  availabilityInformation = availabilityInformation?.map((item, index) => {
    return { ...item, keyindex: index };
  });
  const showContactDealerOnly = shouldShowContactDealer(
    availabilityInformation
  );
  const isQuantityAvailable = (availabilityInformation || []).some(
    ({ quantityAvailable }) => quantityAvailable >= 0
  );
  const shouldShowData =
    isQuantityAvailable || showContactDealerOnly || hoseAssemblyIndicator;

  return (
    <div data-testid="primary-availability">
      <AvailabilityTitle
        hideLabel={hideLabel}
        availabilityToolTipMessage={availabilityToolTipMessage}
        isDeliveryEnabled={isDeliveryEnabled}
        isPickupEnabled={isPickupEnabled}
        hideToolTipIcon={hideToolTipIcon}
      />
      <Conditional test={hoseAssemblyIndicator}>
        <HoseAssemblyDetails hoseAvailabilityLabel={hoseAvailabilityLabel} />
      </Conditional>
      <Conditional test={shouldShowData}>
        {availabilityInformation?.map(
          ({ quantityAvailable, availabilityMessage, keyindex }) => {
            return !availabilityMessage ? (
              <React.Fragment key={keyindex}>
                <span className="fw-bold pe-1">{quantityAvailable}</span>
                <ContactYourDealerPopover
                  dealerAddress={address}
                  variant="inline"
                  className="d-inline-block"
                  msg={availabilityMessage}
                  shouldFitContent
                />
              </React.Fragment>
            ) : (
              <p className="m-0" key={keyindex}>
                <span className="fw-bold pe-1">
                  {quantityAvailable !== 0 && quantityAvailable}
                </span>
                <span className="cat-u-theme-typography-label">
                  {availabilityMessage}
                </span>
              </p>
            );
          }
        )}
        <Conditional test={showAdditionalInfo}>
          <AvailabilityPickupText
            isDeliveryEnabled={isDeliveryEnabled}
            isPickUpEnabled={isPickupEnabled}
          />
        </Conditional>
      </Conditional>
    </div>
  );
};

export default PrimaryAvailability;
